export const icons = {
  editIcon: require("./icons/edit.png"),
  deleteIcon: require("./icons/delete.png"),

};
export const images = {};
